import script from "./DocumentLineAmount.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentLineAmount.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentLineAmount.vue?vue&type=style&index=0&id=14c1ee95&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14c1ee95"]])

export default __exports__